import { isValidPhoneNumber } from 'react-phone-number-input';
export function isValidMobileNumber(value) {
    return isValidPhoneNumber(value);
}
